module.exports = __webpack_public_path__ + "524512b8ed326a9a0a4012ed49198a75.pdf";